import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import {gql, useLazyQuery} from "@apollo/client/index";
import Alert from "@material-ui/lab/Alert/Alert";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import clsx from 'clsx';
import * as ReactGA from "react-ga";
import ApplyCodeRequest from "./ApplyCodeRequest";
import RemoveCodeRequest from "./RemoveCodeRequest";
import Grid from "@material-ui/core/Grid/Grid";
import NotifyRequest from "../Notify/NotifyRequest";

const useStyles = makeStyles((theme) => {
    return {
        alerts: {
            maxWidth: 358
        },
        baseRoot: {
            borderRadius: 0
        },
        input: {
            paddingTop: 14,
            paddingBottom: 11,
            fontWeight: 'bold',
            fontSize: '1.2rem',
            textTransform: 'uppercase',
        },
        helper: {
            marginLeft: 0,
            fontSize: '0.8rem'
        },
        inputMobile: {
            width: '100%'
        },
        makeButton: {
            height: 47,
            borderRadius: 0,
            backgroundColor: '#3e4043',
            color: '#e7edef',
            marginTop: 14,
            marginLeft: 10
        },

        makeButtonMobile: {
            marginTop: 0,
            marginLeft: 0,
            marginBottom: 10
        },

        // --- buy now link

        applyLinkCont: {
            display: 'inline',
            '& p': {
                display: 'inline',
            }

        },
        applyLinkContMobile: {
            top: 0,
            bottom: 'auto',
            borderBottom: 'none',
        },
        applyLinkContMini: {
            fontSize: '0.7rem'
        },
        link: {
            ['@media (max-width:700px)']: {
                marginLeft: '20%'
            },
            ['@media (max-width:360px)']: {
                marginLeft: '10%',
            },
            ['@media (max-width:320px)']: {
                marginLeft: '5%',
            },
        },
        applyLink: {
            color: 'blue',
            textDecoration: 'underline',
            '&:hover': {
                color: "blue",
            },
        },
        applyLinkMobile: {
            borderBottom: '1px solid blue',
        },
        applyCoupon: {
        },
        closeButton: {
            position: 'absolute',
            right: 20,
            background: '#fff',
            border: '1px solid #ccc',
            top: 10,
            zIndex: 1000,
            padding: 5,
            cursor: 'pointer',
            backgroundColor: '#fff',
            borderRadius: 20,
            '&:hover': {
                backgroundColor: '#ccc',
                transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
            }
        },
        dialogHeader: {
            marginTop: 0,
            marginBottom: 5,
        },
        successMessage: {
            padding: 10,
            border: '1px dashed #ccc'
        }
    }
});


export default function ApplyCodeWindow(props) {
    const classes = useStyles();

    const item = props.item;
    const isMobile = props.isMobile;
    const isMicro = props.isMicro;
    const isMini = props.isMini;

    const [open, setOpen] = React.useState();
    const [loading, setLoading] = React.useState();
    const [errorMessage, setErrorMessage] = React.useState();
    const [successMessage, setSuccessMessage] = React.useState();
    const [code, setCode] = React.useState();
    const [remove, setRemove] = React.useState();

    const handleOpenEnterCode = (e) => {
        e.preventDefault();
        setOpen(true);
        ReactGA.event({
            category: 'User',
            action: 'apply_code_open',
            label: item.sn
        });
    };

    const handleInputChange = (e) => {
        setCode(e.target.value.trim());
    };

    const handleClose = () => {
        props.refetch();
        setLoading(false);
        setErrorMessage(null);
        setOpen(false);
        setSuccessMessage(null);
    };

    const onSubmit = e => {
        e.preventDefault();
        if (!code) {
            setErrorMessage('Please enter discount code');
            return;
        }
        setErrorMessage(null);
        setLoading(true);

        ReactGA.event({
            category: 'User',
            action: 'apply_code_submit',
            label: item.sn
        });

    };


    const handleData = (data) => {
        setLoading(false);
        setSuccessMessage(data.message);

    };

    const handleError = (e) => {
        setLoading(false);
        setErrorMessage(e.toString());
    };

    const handleRemoveData = (data) => {
        setRemove(false);
        props.refetch();
    };

    const handleRemoveError = (e) => {
        setRemove(false);
        props.refetch();
    };

    const handleRemoveCode = (e) => {
        e.preventDefault();
        setRemove(true);
    };

    return (
        <>
            {loading ?
                <ApplyCodeRequest sn={item.sn} code={code} onData={handleData} onError={handleError}/>
                : null}

            {remove ?
                <RemoveCodeRequest sn={item.sn} code={code} onData={handleRemoveData} onError={handleRemoveError}/>
                : null}

            {item.dealerPrice ?
            <Grid item xs={12} sm={6} md={4}>
                <Typography className={classes.link}>
                    ▷ {item.appliedDiscount ? <a href="#" className={classes.applyLink} aria-label="Remove" title="Remove"
                       onClick={handleRemoveCode}>Remove (${new Intl.NumberFormat().format((item.appliedDiscount/100))})</a> : <a href="#" className={classes.applyLink}
                       onClick={handleOpenEnterCode} aria-label="Apply discount" title="Apply discount">Apply discount</a>}
                </Typography>
            </Grid> : null}
            <Grid item xs={12} sm={6} md={4}>
                <Typography className={classes.link}>
                    ▷ <a href="/membership" className={classes.applyLink} aria-label="Free coupon" title="Free coupon">
                        Free coupon</a>
                </Typography>
            </Grid>
            {open ? <NotifyRequest data={"Apply discount click: "+props.item.sn}/> : null}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-discount-code-apply">
                <CloseIcon className={classes.closeButton} onClick={handleClose}/>
                <DialogContent>
                    <Typography variant={"h6"} className={classes.dialogHeader}>Enter discount code</Typography>
                    <div className={classes.alerts}>
                        {loading ? <Alert severity="info"
                                          icon={<CircularProgress size={20} disableShrink/>}>
                            Applying discount code. Please wait...
                        </Alert> : null}
                        {errorMessage ? <Alert severity="error" disableShrink>
                            {errorMessage}
                        </Alert> : null}
                    </div>
                    {successMessage ? <><Alert severity="success" disableShrink>
                        {successMessage}
                    </Alert><br/></> : null}
                    {!successMessage ?
                        <form className={classes.root} noValidate autoComplete="off" onSubmit={onSubmit}>
                                <TextField
                                required
                                id="outlined-basic"
                                label=""
                                variant="outlined"
                                className={clsx(classes.input, isMobile ? classes.inputMobile : null)}
                                name="code"
                                disabled={loading}
                                helperText="Example: XXXYYY"
                                onChange={handleInputChange}
                                InputProps={{
                                    classes: {
                                        input: classes.input,
                                        root: classes.baseRoot,
                                        label: classes.label,
                                    },
                                }}
                                FormHelperTextProps={{ classes: { root: classes.helper } }}
                            />
                            <Button type="submit" variant="contained" size="large" color="primary"
                                    className={clsx(classes.makeButton, isMobile ? classes.makeButtonMobile : null)}
                                    disabled={loading}>
                                Apply
                            </Button>
                        </form> : null}
                </DialogContent>
            </Dialog>
        </>
    );
}
